import { BetterDataSection } from "components/programmatic/BetterDataSection";
import { FeaturesSection } from "components/programmatic/FeaturesSection";
import { Footer } from "components/programmatic/Footer";
import { Header } from "components/programmatic/Header";
import { ProgrammaticHero } from "components/programmatic/ProgrammaticHero";
import { OverviewSection } from "components/programmatic/OverviewSection";
import { PrivacySection } from "components/programmatic/PrivacySection";
import { TagSilhouetteBackground } from "components/programmatic/TagSilhouetteBackground";
import { TestimonialsSection } from "components/programmatic/TestimonialsSection";
import { TitleAndMetaTags } from "components/TitleAndMetaTags";

export default function ProgrammaticHome() {
  return (
    <div>
      <TitleAndMetaTags
        title="Humanloop Programmatic – Powerful weak labelling"
        description="An annotation tool to create large high-quality datasets for NLP in minutes. No hand labelling required."
        image="Social share programmatic gradient.png"
      />
      <main>
        <TagSilhouetteBackground>
          <Header />
          <ProgrammaticHero />
        </TagSilhouetteBackground>
        <OverviewSection />
        <BetterDataSection />
        <FeaturesSection />
        <PrivacySection />
        <TestimonialsSection />
        <Footer />
      </main>
    </div>
  );
}
